import type { RequiredGeneric } from '@pba/react-utils';
import {
  AttachmentsInput,
  FormSection,
  Icon,
  type RcCustomRequestOptions,
  type UploadChangeParam,
  type UploadFile,
} from 'ui';

export type AttachmentsFormContentValues = {
  attachments?: { fileList: UploadFile[] } | UploadChangeParam<UploadFile>;
};

const customRequest = ({ onSuccess }: RcCustomRequestOptions) => {
  onSuccess?.({});
};

const AttachmentsFormContent = <T extends AttachmentsFormContentValues = never>(_: RequiredGeneric<T>) => (
  <FormSection title={{ children: 'Attachments', icon: <Icon icon="attachment-line" /> }}>
    <AttachmentsInput
      input={{ customRequest }}
      item={{ label: 'Attach files', name: 'attachments' }}
      showThirdPartyUploads={false}
      uploadButtonType="bulk"
    />
  </FormSection>
);

export default AttachmentsFormContent;
